import React from 'react';
import Field, { FieldProps } from '../../../../../../../components/forms/fields/Field';
import { Counter, CounterProps } from '../../../../../../../ui-kit';

type CounterFieldProps<P> = Omit<FieldProps<P, CounterProps>, 'renderer'>;

const CounterField = <P, >(props: CounterFieldProps<P>) => <Field renderer={Counter} {...props} />;

export default CounterField;